export const teamInfo = [
  {
    name: 'Team member amount',
    value: '000'
  },
  {
    name: 'Active',
    value: '000'
  },
  {
    name: 'Passive',
    value: '000'
  },
  {
    name: 'Dead',
    value: '000'
  },
  {
    name: 'Outperform',
    value: '000'
  }
];
